import { cx } from "class-variance-authority";
import { ListBoxItem } from "react-aria-components";
import { useTranslation } from "react-i18next";

import { AddIcon } from "@/assets/icons/ui/Add";
import type { AutocompleteItem } from "@/components/ui/inputs/Autocomplete/Autocomplete";

export const autocompleteListItemStyles = {
  item: ({ isNewItem = false }: { isNewItem?: boolean }) =>
    cx(
      "text-desktop-body-3 font-labels-default",
      "group flex cursor-pointer items-center px-4 py-2",
      "outline-none",
      "bg-elevation-surface-1",
      "hover:bg-elevation-surface-2",
      "focus-visible:bg-interactive-primary-focus focus-visible:text-interactive-text-on-inverted",
      "selected:bg-interactive-primary-idle selected:text-interactive-text-on-inverted",
      isNewItem ? "text-text-default-highlight-2" : "text-interactive-text-on-bg",
    ),
  icon: "h-4 w-4 pr-1 text-text-default-highlight-2",
};

interface Props {
  item: AutocompleteItem;
  isNewItem?: boolean;
  newItemTypeLabel?: string;
  index: number;
}

export const AutocompleteListItem = ({ item, isNewItem, newItemTypeLabel, index }: Props) => {
  const { t } = useTranslation();

  return (
    <ListBoxItem
      id={item.id}
      data-index={index}
      className={cx(autocompleteListItemStyles.item({ isNewItem }))}
      textValue={item.label}
    >
      {isNewItem ? <AddIcon className={cx(autocompleteListItemStyles.icon)} /> : null}
      {isNewItem ? `${t("ui.autocomplete.createNewBtn", { query: item.label })} ${newItemTypeLabel || ""}` : item.label}
    </ListBoxItem>
  );
};
